module.exports = __webpack_public_path__ + "static/media/kn.1459b596.svg";